/* Estado agotado para el bloque de compra.

   POR QUÉ EXISTE ESTE ARCHIVO. feel-pdp-main.liquid no contempla que una
   variante esté sin stock: pinta siempre "add to cart · precio" y el botón
   queda activo. Shopify marca el producto como no disponible, pero
   /cart/add.js acepta igual y el bloqueo real solo llega en el checkout, así
   que el cliente añade al carrito y se entera al final. Comprobado en vivo
   con Serenity Brew a cero: la petición devolvió 200.

   POR QUÉ NO SE ARREGLA EN EL LIQUID, QUE SERÍA LO CORRECTO. Ese archivo pesa
   31 KB y la API de temas no admite escrituras de más de 16.384 caracteres,
   así que no se puede reescribir sin partirlo antes en varios assets. Esto es
   el parche seguro; la refactorización queda pendiente.

   LIMITACIÓN QUE HAY QUE CONOCER. Al depender de javascript, durante un
   instante el botón se ve comprable antes de corregirse, y con el script
   caído no se corrige nunca. El checkout sigue protegiendo la venta en los
   dos casos: nadie llega a pagar algo que no hay. */
(function () {
  'use strict';

  var cta   = document.querySelector('[data-fc-cta]');
  var hidden= document.querySelector('input[data-fc-variant]');
  if (!cta || !hidden) return;

  var packs  = [].slice.call(document.querySelectorAll('[data-fc-packs] [data-variant]'));
  var sticky = document.querySelector('[data-fc-sticky-cta]');
  var LABEL  = 'sold out';
  var avail  = null;              // id -> boolean, null mientras no se sepa

  var css = document.createElement('style');
  css.textContent =
    '[data-fc-cta][disabled],[data-fc-sticky-cta][disabled]{opacity:.45;cursor:not-allowed}' +
    '.fc-opt[aria-disabled="true"]{opacity:.45;cursor:not-allowed}' +
    '.fc-out-tag{font-family:var(--fc-mono);font-size:.62rem;letter-spacing:.14em;' +
    'text-transform:uppercase;border:1px solid currentColor;border-radius:999px;' +
    'padding:.15rem .5rem;margin-left:.5rem;white-space:nowrap}';
  document.head.appendChild(css);

  function paint() {
    if (!avail) return;
    var id = hidden.value;
    // Una variante que no está en el mapa se trata como disponible: es mejor
    // dejar comprar algo que quizá no hay (lo frena el checkout) que bloquear
    // una venta buena porque el catálogo no respondió como se esperaba.
    var ok = avail[id] !== false;

    [cta, sticky].forEach(function (b) {
      if (!b) return;
      if (ok) {
        if (b.dataset.fcOutPrev) { b.textContent = b.dataset.fcOutPrev; delete b.dataset.fcOutPrev; }
        b.disabled = false;
        b.removeAttribute('aria-disabled');
      } else {
        if (!b.dataset.fcOutPrev) b.dataset.fcOutPrev = b.textContent;
        b.textContent = LABEL;
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function markPacks() {
    packs.forEach(function (p) {
      if (avail[p.getAttribute('data-variant')] !== false) return;
      p.setAttribute('aria-disabled', 'true');
      if (!p.querySelector('.fc-out-tag')) {
        var tag = document.createElement('span');
        tag.className = 'fc-out-tag';
        tag.textContent = LABEL;
        var title = p.querySelector('b') || p;
        title.appendChild(tag);
      }
    });
  }

  // El tema cambia la variante asignando input.value, que no dispara ningún
  // evento ni ninguna mutación observable. El único disparador fiable es el
  // clic en el selector, y se lee en el tick siguiente para que el handler
  // del tema haya escrito ya su valor.
  var wrap = document.querySelector('[data-fc-packs]');
  if (wrap) {
    wrap.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-variant]');
      if (opt && opt.getAttribute('aria-disabled') === 'true') {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      setTimeout(paint, 0);
    }, true);
    wrap.addEventListener('click', function () { setTimeout(paint, 0); });
  }
  document.addEventListener('change', function () { setTimeout(paint, 0); });

  fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.products) return;
      avail = {};
      data.products.forEach(function (p) {
        (p.variants || []).forEach(function (v) { avail[String(v.id)] = !!v.available; });
      });
      markPacks();
      paint();
    })
    .catch(function () { /* sin datos se deja el botón como estaba */ });
})();